import { REGULATORY_STATEMENTS } from 'src/constants';
import { RegulatoryStatement } from 'src/types/menu.types';

// Generic helper to check if a regulatory statement exists by name
export const hasRegulatoryStatement = (regulatoryStatements: RegulatoryStatement[], statementName: string): boolean => {
  return regulatoryStatements?.some((statement) => statement.name === statementName) ?? false;
};

// Format flags to regulatory statements payload
export const formatFlagsToRegulatoryStatements = (currentItem: { is_hfss?: boolean; age_verification?: boolean }) => {
  const flagToStatementMap = [
    { flag: currentItem.is_hfss, code: REGULATORY_STATEMENTS.HFSS.code },
    { flag: currentItem.age_verification, code: REGULATORY_STATEMENTS.AGE_VERIFICATION.code },
  ];

  return {
    regulatory_statements: flagToStatementMap.filter(({ flag }) => flag).map(({ code }) => code),
  };
};
